// src/API/Lesson/TranslationMediatorAPI.tsx
import apiClient from "../../services/apiClient";
import { mobileAppUri, dataLoaderUri } from "../API";

export interface TranslationMediatorTurn {
  turnIndex: number;
  speaker: "A" | "B";
  originalText: string;
  audioUrl?: string;
  expectedTranslation: string;
  expectedTranslationAudioUrl?: string;
  hintText?: string;
}

export interface TranslationMediatorExercise {
  sectionId: string;
  exerciseId: string;
  conversationTopic: string;
  baseLanguage: string;
  targetLanguage: string;
  proficiencyLevel: string;
  difficulty: string;
  avatarAName: string;
  avatarBName: string;
  avatarAGender: string;
  avatarBGender: string;
  turns: TranslationMediatorTurn[];
  createdAt?: string;
}

export async function fetchTranslationMediatorExercises(
  sectionName: string
): Promise<TranslationMediatorExercise[]> {
  if (!sectionName) return [];

  try {
    const responseData = await apiClient.get(`${mobileAppUri}/api/v1/translation-mediator`, {
      params: { section: sectionName },
    });

    if (responseData && Array.isArray(responseData.items)) {
      return responseData.items;
    }
    return [];
  } catch (error) {
    console.error("Error fetching translation mediator exercises:", error);
    throw error;
  }
}

export async function createTranslationMediatorExercise(exerciseData: TranslationMediatorExercise) {
  const url = `${dataLoaderUri}/api/v1/translation-mediator-exercises`;
  try {
    return await apiClient.post(url, exerciseData);
  } catch (error) {
    console.error("Error creating translation mediator exercise:", error);
    throw error;
  }
}

export async function updateTranslationMediatorExercise(
  sectionId: string,
  exerciseId: string,
  updateData: Partial<TranslationMediatorExercise>
) {
  const url = `${dataLoaderUri}/api/v1/translation-mediator-exercises/${sectionId}/${exerciseId}`;
  try {
    return await apiClient.put(url, updateData);
  } catch (error) {
    console.error("Error updating translation mediator exercise:", error);
    throw error;
  }
}

export async function deleteTranslationMediatorExercise(sectionId: string, exerciseId: string) {
  const url = `${dataLoaderUri}/api/v1/translation-mediator-exercises/${sectionId}/${exerciseId}`;
  try {
    return await apiClient.delete(url);
  } catch (error) {
    console.error("Error deleting translation mediator exercise:", error);
    throw error;
  }
}
